import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface DebitWalletManuallyResult {
  id: string;
  accountId: number;
  amount: number;
  balanceBefore: number;
  balanceAfter: number;
  createdAt: number;
}

@Injectable({
  providedIn: 'root',
})
export class WalletService {
  private readonly baseUrl = `${environment.api}/wallet`;
  private readonly administrativeBaseUrl = `${environment.api_v2}/v2/administrative/wallet`;

  constructor(private readonly http: HttpClient) {}

  getAmount(params: { accountId: number }): Observable<{ amount: number }> {
    const queryParams = new HttpParams().set('accountId', params.accountId);

    return this.http.get<{ amount: number }>(`${this.baseUrl}`, {
      params: queryParams,
    });
  }

  debitManually(params: {
    accountId: number;
    amount: number;
    justification: string;
  }): Observable<DebitWalletManuallyResult> {
    return this.http.post<DebitWalletManuallyResult>(`${this.administrativeBaseUrl}/debit`, params);
  }

  depositManually(params: {
    accountId: number;
    amount: number;
    justification: string;
  }): Observable<DebitWalletManuallyResult> {
    return this.http.post<DebitWalletManuallyResult>(`${this.administrativeBaseUrl}/deposit`, params);
  }
}
